import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Index/HomePage.vue'
// import store from '@/store'

Vue.use(VueRouter)

const routes = [
    // 路由重新定向
    {
        path: '/',
        redirect: "/index"
    },
    // 登录页
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import("@/views/Login/LoginPage.vue"),
    },
    // 首页
    {
        path: '/index',
        name: 'HomePage',
        component: HomePage,
        // redirect: "/index",  // 重定向
        meta: {
            requiresAuth: true,
            content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
        children:[
            {
                path: '/index',
                name: '工作台',
                component: () => import("@/views/Index/indexPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            }, {
                path: '/progress',
                name: '进度提示',
                component: () => import("@/views/Index/progressPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/admin',
                name: '管理员',
                component: () => import("@/views/User/adminManagerPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/adminDetail',
                name: '管理员详情',
                component: () => import("@/views/User/adminDetailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/user',
                name: '用户管理',
                component: () => import("@/views/User/userManagerPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/userDetail',
                name: '用户详情',
                component: () => import("@/views/User/userDetailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/robot',
                name: '机器人佣金',
                component: () => import("@/views/User/robotPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/setting',
                name: '系统设置',
                component: () => import("@/views/System/settingPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/deposit',
                name: '保证金',
                component: () => import("@/views/System/depositPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/commission',
                name: '佣金',
                component: () => import("@/views/System/commissionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },{
                path: '/announcementNotice',
                name: '公告提示',
                component: () => import("@/views/System/announcementNoticePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },{
                path: '/banner',
                name: 'banner图片',
                component: () => import("@/views/System/bannerPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },{
                path: '/fission',
                name: '裂变管理',
                component: () => import("@/views/System/fissionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },{
                path: '/taskReminder',
                name: '任务提醒',
                component: () => import("@/views/System/taskReminderPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/proxyBidding',
                name: '代拍',
                component: () => import("@/views/System/proxyBiddingPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/levelSelection',
                name: '登记选择',
                component: () => import("@/views/System/levelSelectionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/phoneSeries',
                name: '手机系列',
                component: () => import("@/views/ModelProfile/seriesPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/phoneModel',
                name: '手机机型',
                component: () => import("@/views/ModelProfile/modelPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/phoneColor',
                name: '手机颜色',
                component: () => import("@/views/ModelProfile/colorPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 基本信息  存储容量
            {
                path: '/storageCapacity',
                name: '存储容量',
                component: () => import("@/views/JBXX/storagePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/warrantyPeriod',
                name: '保修期时长',
                component: () => import("@/views/JBXX/warrantyPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/channel',
                name: '渠道',
                component: () => import("@/views/JBXX/channelPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/battery',
                name: '电池',
                component: () => import("@/views/JBXX/batteryPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // {
            //     path: '/chargeCycles',
            //     name: '充电次数',
            //     component: () => import("@/views/JBXX/chargeCyclesPage.vue"),
            //     meta: {
            //         requiresAuth: true,
            //         content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            //     },
            // },
            // 外观成色
            {
                path: '/fuselage',
                name: '机身',
                component: () => import("@/views/WGCS/fuselagePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/screenAppearance',
                name: '屏幕外观',
                component: () => import("@/views/WGCS/screenAppearancePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/screenDisplay',
                name: '屏幕显示',
                component: () => import("@/views/WGCS/screenDisplayPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/borderBackplate',
                name: '边框背板',
                component: () => import("@/views/WGCS/borderBackplatePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 拆修情况
            {
                path: '/frontCamera',
                name: '前摄像头',
                component: () => import("@/views/CXQK/frontCameraPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/rearCamera',
                name: '后摄像头',
                component: () => import("@/views/CXQK/rearCameraPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/rearCase',
                name: '后壳',
                component: () => import("@/views/CXQK/rearCasePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/powerBank',
                name: '电池',
                component: () => import("@/views/CXQK/powerBankPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/functionalParts',
                name: '功能零件',
                component: () => import("@/views/CXQK/functionalPartsPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/screen',
                name: '屏幕',
                component: () => import("@/views/CXQK/screenPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/motherboard',
                name: '主板',
                component: () => import("@/views/CXQK/motherboardPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 使用功能
            {
                path: '/afterSales',
                name: '售后维修案例',
                component: () => import("@/views/SYGN/afterSalesPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/powerOn',
                name: '开机情况等',
                component: () => import("@/views/SYGN/powerOnPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/restoreFactorySettings',
                name: '是否可恢复出厂设置',
                component: () => import("@/views/SYGN/restoreFactorySettingsPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/frontFacingCamera',
                name: '前摄拍照摄像',
                component: () => import("@/views/SYGN/frontFacingCameraPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/rearCameraPhotography',
                name: '后摄拍照摄像',
                component: () => import("@/views/SYGN/rearCameraPhotographyPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/call',
                name: '通话功能',
                component: () => import("@/views/SYGN/callPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/sound',
                name: '声音功能',
                component: () => import("@/views/SYGN/soundPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/confirmLogout',
                name: 'icloud是否注销',
                component: () => import("@/views/SYGN/confirmLogoutPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/charging',
                name: '充电功能',
                component: () => import("@/views/SYGN/chargingPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/wireless',
                name: '无线功能',
                component: () => import("@/views/SYGN/wirelessPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/compass',
                name: '指南针功能',
                component: () => import("@/views/SYGN/compassPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/touch',
                name: '触摸功能',
                component: () => import("@/views/SYGN/touchPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/faceRecognition',
                name: '面容识别功能',
                component: () => import("@/views/SYGN/faceRecognitionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/screenSensor',
                name: '屏幕传感器功能',
                component: () => import("@/views/SYGN/screenSensorPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/vibration',
                name: '震动功能',
                component: () => import("@/views/SYGN/vibrationPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/dataConnection',
                name: '数据连接功能',
                component: () => import("@/views/SYGN/dataConnectionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/sideButton',
                name: '侧键',
                component: () => import("@/views/SYGN/sideButtonPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/auctionPhone',
                name: '待拍库',
                component: () => import("@/views/DPK/auctionPhonePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/addAuctionPhone',
                name: '新增',
                component: () => import("@/views/DPK/addAuctionPhonePage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/qualityInspection',
                name: '质检库',
                component: () => import("@/views/DPK/qualityInspectionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/priceVerification',
                name: '核价库',
                component: () => import("@/views/DPK/priceVerificationPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/modelDetails',
                name: '新增',
                component: () => import("@/views/DPK/modelDetailsPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/task',
                name: '任务库',
                component: () => import("@/views/DPK/taskPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/taskDetail',
                name: '任务详情',
                component: () => import("@/views/DPK/taskDetailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/pendingOrder',
                name: '待确认订单',
                component: () => import("@/views/DPK/pendingOrderPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },{
                path: '/refundFailed',
                name: '退款异常',
                component: () => import("@/views/DPK/refundFailedPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/photo',
                name: '任务详情',
                component: () => import("@/views/DPK/photoPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
        ]
    },
   
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})



const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err);
}

router.beforeEach((to, from, next) => {
    console.log(1111,to,from);
    const isLoginRequired = to.matched.some(record => record.meta.requiresAuth)
    const isLogin = localStorage.getItem('isLogin')
    if (isLoginRequired && !isLogin) {
        next('/login') // 未登录则重定向到登录页面
    } else {
        // 已登录，或者不需要登录的页面，正常导航
        next()
    }
  })
  
router.afterEach((to, from) => {
    // 在路由切换后滚动到页面顶部
    console.log('路由切换',to.path,from.path);
    if (to.path !== from.path) {
        window.scrollTo(0, 0); // 将滚动条位置设置到页面最顶部
    }
})



export default router
